import { render, staticRenderFns } from "./VAutocompleteSpeaker.vue?vue&type=template&id=52c332a6&scoped=true"
import script from "./VAutocompleteSpeaker.vue?vue&type=script&lang=js"
export * from "./VAutocompleteSpeaker.vue?vue&type=script&lang=js"
import style0 from "./VAutocompleteSpeaker.vue?vue&type=style&index=0&id=52c332a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c332a6",
  null
  
)

export default component.exports